import React from 'react';
import {useNode} from '@craftjs/core';
import {Divider} from 'components';
import {useEditorStyle} from 'hooks';
import EditorInspectorVisible from './Editor.Inspector.Visible';

export interface IChildrenProps {
  style: React.CSSProperties | undefined;
  setProp: ReturnType<typeof useNode>['actions']['setProp'];
}

interface IEditorInspectorProps {
  title: string;
  defaultDisplay?: 'block' | 'flex';
  children: ({style, setProp}: IChildrenProps) => React.ReactNode;
}

const EditorInspector = ({children, title, defaultDisplay = 'block'}: IEditorInspectorProps) => {
  const {device, style} = useEditorStyle();
  const {
    actions: {setProp},
  } = useNode(node => node.data.props);
  return (
    <div key={device} className="pt-0.5">
      <h2 className="text-slate-800 dark:text-white font-semibold">{title}</h2>
      <Divider />
      <div className="flex flex-col">
        <EditorInspectorVisible style={style} setProp={setProp} defaultDisplay={defaultDisplay} />
        <Divider />
        {children({style, setProp})}
      </div>
    </div>
  );
};

export default React.memo(EditorInspector);
